import { SpoUserSettingsResponse } from '@spo/types';

export type Filters = {
  productManagerIds: string[];
  productNatureIds: number[];
  retailFamilyIds: number[];
  segmentationIds: number[];
  sportIds: number[];
};

export const buildFiltersParams = (
  userConfig: SpoUserSettingsResponse | undefined,
  selectedFilters: Filters,
) => {
  const filtersParam: Filters = {
    productManagerIds: [],
    productNatureIds: [],
    retailFamilyIds: [],
    segmentationIds: [],
    sportIds: [],
  };

  if (userConfig && !userConfig.needRedirect) {
    filtersParam.productManagerIds.push(...selectedFilters.productManagerIds);

    if (userConfig.productNatureIds) {
      const pnids =
        selectedFilters.productNatureIds.length > 0
          ? selectedFilters.productNatureIds
          : userConfig.productNatureIds;
      filtersParam.productNatureIds.push(...pnids);
    }

    if (userConfig.retailFamilyIds) {
      const rfids =
        selectedFilters.retailFamilyIds.length > 0
          ? selectedFilters.retailFamilyIds
          : userConfig.retailFamilyIds;
      filtersParam.retailFamilyIds.push(...rfids);
    }

    filtersParam.segmentationIds.push(...selectedFilters.segmentationIds);

    if (userConfig.sportIds) {
      const sids =
        selectedFilters.sportIds.length > 0
          ? selectedFilters.sportIds
          : userConfig.sportIds;
      filtersParam.sportIds.push(...sids);
    }
  }

  return filtersParam;
};
